import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierSceneIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M4 7V17C4 17.55 4.45 18 5 18H19C19.55 18 20 17.55 20 17V7C20 6.45 19.55 6 19 6H5C4.45 6 4 6.45 4 7ZM6 8H18V16H6V8Z"
        fill={color}
      />
      <path
        d="M1 8C1.55 8 2 7.55 2 7V4H5C5.55 4 6 3.55 6 3C6 2.45 5.55 2 5 2H1C0.45 2 0 2.45 0 3V7C0 7.55 0.45 8 1 8Z"
        fill={color}
      />
      <path
        d="M23 2H19C18.45 2 18 2.45 18 3C18 3.55 18.45 4 19 4H22V7C22 7.55 22.45 8 23 8C23.55 8 24 7.55 24 7V3C24 2.45 23.55 2 23 2Z"
        fill={color}
      />
      <path
        d="M5 20H2V17C2 16.45 1.55 16 1 16C0.45 16 0 16.45 0 17V21C0 21.55 0.45 22 1 22H5C5.55 22 6 21.55 6 21C6 20.45 5.55 20 5 20Z"
        fill={color}
      />
      <path
        d="M23 16C22.45 16 22 16.45 22 17V20H19C18.45 20 18 20.45 18 21C18 21.55 18.45 22 19 22H23C23.55 22 24 21.55 24 21V17C24 16.45 23.55 16 23 16Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierSceneIcon.displayName = 'HierSceneIcon';
